import { render, staticRenderFns } from "./ManifestFilters.vue?vue&type=template&id=4cc37b48&scoped=true&"
import script from "./ManifestFilters.vue?vue&type=script&lang=ts&"
export * from "./ManifestFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc37b48",
  null
  
)

export default component.exports